import { ResizablePanel, ResizablePanelGroup } from "@/components/ui/resizable";
import { TemplateContent } from "@/components/template/TemplateContent";
import "@/styles/TemplateDocument.css";

type DocumentPreviewProps = {
  content: string;
};

export function DocumentPreview({ content }: DocumentPreviewProps) {
  return (
    <ResizablePanelGroup direction="horizontal">
      <ResizablePanel defaultSize={50}>
        <div className="h-[60vh] overflow-auto bg-white">
          <div className="p-6">
            <TemplateContent 
              content={content}
              displayAsForm={false}
            />
          </div>
        </div>
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}